import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { JiraObjectDataset } from 'app/model/dataset/jira.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { JiraLinkedService } from 'app/model/linkedservice/jira.linkedservice';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { TabularTypeDataset } from 'app/model/dataset/tabular-type.dataset';
import { separateTableSchemaFromPath } from 'app/model/dataset/tabular-type-utils';
import { ModelConstants } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(JiraObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class JiraObjectDatasetAdapter extends TabularTypeDatasetAdapter<JiraObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: JiraObjectDataset): Promise<Model.DatasetResource> {
        const resource = await this._toResourceInternal(dataset, Metamodel.modelFor(JiraObjectDataset).name);
        const linkedService = dataset.linkedService as JiraLinkedService;
        const isCopyJob = Metamodel.modelOf(dataset.owner)?.name === ModelConstants.copyJobActivity;
        if (isCopyJob && linkedService?.version === driverVersions.v2) {
            const properties = this.properties(resource) as Model.JiraObjectDataset;
            const tableName = ValueAdapter.toResource(dataset, TabularTypeDataset.TABLE_NAME);
            const [schemaFromPath, tableFromPath] = separateTableSchemaFromPath(tableName, '.');
            properties.typeProperties.schema =
                ValueAdapter.toResource(dataset, TabularTypeDataset.SCHEMA) ?? schemaFromPath;
            properties.typeProperties.table =
                ValueAdapter.toResource(dataset, TabularTypeDataset.TABLE) ??
                properties.typeProperties.table ??
                tableFromPath;
            Reflect.deleteProperty(properties.typeProperties, 'tableName');
        }
        return resource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: JiraObjectDataset): Promise<JiraObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, JiraObjectDataset.MODEL);
    }
}
